// Modal launched from workflow, eg, when user moves date marker
import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';

// components
import { FormButtons } from 'components-design-system'
import useOnClickOutside from 'utilities/useOnClickOutside';
// styles
import './ConfirmChangesModal.scss';

const ConfirmChangesModal = (props) => {
  const [showModal, setShowModal] = useState(true);
  const ref = useRef()

  const {
    state,
    ghostState,
    onSaveStateDates,
    onRevertStateDates,
    openConfirmDateChangeModal,
    setConfirmDateChangeModal,
    closeGhostState
  } = props;

  const onCancel = () => {
    setConfirmDateChangeModal(false)
    onRevertStateDates()
  }

  useOnClickOutside(ref, onCancel)

  useEffect(() => {
    if (openConfirmDateChangeModal) {
      if (dayjs(ghostState.start_state_date).format("YYYY-MM-DD") !== dayjs(state.start_state_date).format("YYYY-MM-DD")
        || dayjs(ghostState.end_state_date).format("YYYY-MM-DD") !== dayjs(state.end_state_date).format("YYYY-MM-DD")) {
        setShowModal(true)
      } else {
        setConfirmDateChangeModal(false)
        closeGhostState()
      }
    }
  }, [openConfirmDateChangeModal])

  if (showModal === false) {
    return null;
  }

  return (
    <div
      ref={ref}
      className="confirm-state-dates-action-container">
      <FormButtons
        onCancel={onCancel}
        cancelButtonProps={{
          className: "no-text-highlight",
          onClick: onCancel
        }}
        okText="Confirm"
        onOk={() => {
          onSaveStateDates(ghostState)
          setConfirmDateChangeModal(false)
        }}
        okButtonProps={{
          width: "100%",
          className: "no-text-highlight",
        }}
      />
    </div>
  );
};

export default ConfirmChangesModal;